import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

export interface WebsocketState {
    messages: any,
    last: any,
    ws: WebSocket | null;
    connected: boolean
}

const initialState: WebsocketState = {
    ws: null,
    messages: [],
    last: [],
    connected: false
};

const Websocket = createSlice({
    name: 'websocket',
    initialState,
    reducers: {
        websocketMessageReceived: (state, action: PayloadAction<any>) => {
            state.messages.push(action.payload);
            state.last = action.payload;
        },
        websocketConnection: (state, action: PayloadAction<any>) => {
            state.ws = action.payload;
        },
        websocketConnected: (state) => {
            state.connected = true;
        },
        websocketDisconnected: (state) => {
            state.connected = false;
        }
    }
});

export const {
    websocketMessageReceived,
    websocketConnected,
    websocketDisconnected,
    websocketConnection
} = Websocket.actions;

export default Websocket.reducer;
